import { ProjectionType } from '../shared/ProjectionDropdown/ProjectionDropdown';

/**
 * Static list of supported projection types for the toolbar.
 */
export const TOOLBAR_PROJECTIONS: ProjectionType[] = [
    { id: 'perspective', name: 'Perspective', isParent: true },
    { id: 'orthographic', name: 'Orthographic', isParent: true },
    { id: 'top', name: 'Top' },
    { id: 'bottom', name: 'Bottom' },
    { id: 'left', name: 'Left' },
    { id: 'right', name: 'Right' },
    { id: 'front', name: 'Front' },
    { id: 'back', name: 'Back' },
]; 